export function calculateBoundingBoxForSelectedElements(design, layer) {
  const scale = design.preview_scale * 72,
    imageElements = layer.image_elements.filter(
      (element) => element.is_selected,
    ),
    textElements = layer.text_elements.filter((element) => element.is_selected),
    boundingbox = { minX: null, minY: null, maxX: null, maxY: null };

  function expandBoundingBox(element) {
    if (
      boundingbox.minX > element.left_position * scale ||
      boundingbox.minX === null
    ) {
      boundingbox.minX = element.left_position * scale;
    }
    if (
      boundingbox.minY > element.top_position * scale ||
      boundingbox.minY === null
    ) {
      boundingbox.minY = element.top_position * scale;
    }

    if (
      boundingbox.maxX < (element.left_position + element.width) * scale ||
      boundingbox.maxX === null
    ) {
      boundingbox.maxX = (element.left_position + element.width) * scale;
    }
    if (
      boundingbox.maxY < (element.top_position + element.height) * scale ||
      boundingbox.maxY === null
    ) {
      boundingbox.maxY = (element.top_position + element.height) * scale;
    }
    boundingbox.width = boundingbox.maxX - boundingbox.minX;
    boundingbox.height = boundingbox.maxY - boundingbox.minY;
  }

  imageElements.forEach(expandBoundingBox);
  textElements.forEach(expandBoundingBox);
  return boundingbox;
}
